module.exports = __webpack_public_path__ + "static/media/browser-ie.86534a9c.svg";